import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { FC } from 'react';
import { LocationModalProps } from '../../app/interfaceTypes';
import RoomIcon from '@mui/icons-material/Room';
import { LABEL_PHONE_LOCATION } from '../../../../shared/lib/constants';

const LocationModal: FC<LocationModalProps> = ({ latitude, longitude, onClose, open, phone, createdAt }) => {
  const formatDateTime = (dateString?: string) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const getLast4Digits = (phoneNumber?: string | null) => {
    if (!phoneNumber) return '';
    return phoneNumber.length >= 4 ? phoneNumber.slice(-4) : phoneNumber;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="location-dialog-title"
      sx={{ zIndex: '99999' }}
      PaperProps={{
        sx: {
          p: 1.5,
          borderRadius: 3,
          boxShadow: 8,
          bgcolor: 'background.paper'
        }
      }}
    >
      <DialogTitle
        id="location-dialog-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          fontWeight: 600,
          fontSize: '1.25rem',
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          pb: 1.5
        }}
      >
        <RoomIcon color="primary" />
        {LABEL_PHONE_LOCATION}
      </DialogTitle>

      {(phone || createdAt) && (
        <Box
          sx={{
            px: 3,
            pt: 2,
            pb: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}
        >
          {phone && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <strong>Phone:</strong> ••• •••• {getLast4Digits(phone)}
            </Typography>
          )}
          {createdAt && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <strong>Captured at:</strong> {formatDateTime(createdAt)}
            </Typography>
          )}
        </Box>
      )}

      <DialogContent
        sx={{
          mt: 2,
          px: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: { xs: 300, sm: 400, md: 450 },
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 3
          }}
        >
          <iframe
            title="Google Map Location"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${latitude},${longitude}&z=18&output=embed`}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          justifyContent: 'flex-end'
        }}
      >
        <Button sx={{ mt: 1 }} onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationModal;
